"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupMetrics = exports.Metrics = exports.findMetricByStatsWidgetMetric = exports.findMetricByAliasOrId = exports.findMetricByAlias = exports.isMetricStandaloneCalendarGroup = exports.MergedMetrics = exports.MetricsDict = void 0;
const metrics_abstract_1 = require("./metrics.abstract");
Object.defineProperty(exports, "Metrics", { enumerable: true, get: function () { return metrics_abstract_1.Metrics; } });
Object.defineProperty(exports, "GroupMetrics", { enumerable: true, get: function () { return metrics_abstract_1.GroupMetrics; } });
exports.MetricsDict = Object.fromEntries(metrics_abstract_1.Metrics.map(metric => ([metric.alias, metric,])));
exports.MergedMetrics = [...metrics_abstract_1.GroupMetrics, ...metrics_abstract_1.Metrics,];
const isMetricStandaloneCalendarGroup = (metric) => {
    return ['hour_of_day', 'weekday',].includes(metric.alias);
};
exports.isMetricStandaloneCalendarGroup = isMetricStandaloneCalendarGroup;
const findMetricByAlias = (alias) => {
    return metrics_abstract_1.Metrics.find(m => m.alias === alias);
};
exports.findMetricByAlias = findMetricByAlias;
const findMetricByAliasOrId = (alias_or_id, stats_custom_metrics) => {
    if (!alias_or_id)
        return undefined;
    return isNaN(alias_or_id) ? [...metrics_abstract_1.Metrics, ...metrics_abstract_1.GroupMetrics,].find(m => m.alias === alias_or_id) : stats_custom_metrics.find(cm => cm.id === alias_or_id);
};
exports.findMetricByAliasOrId = findMetricByAliasOrId;
const findMetricByStatsWidgetMetric = (metric, stats_custom_metrics) => {
    return metric.alias ? [...metrics_abstract_1.Metrics, ...metrics_abstract_1.GroupMetrics,].find(m => m.alias === metric.alias) : stats_custom_metrics.find(cm => cm.id === metric.stats_custom_metric_id);
};
exports.findMetricByStatsWidgetMetric = findMetricByStatsWidgetMetric;
